import '@nematis/event-tracker/lib/init'

// use absolute path to import Webpack assets during runtime (needed for dynamic imports)
// eslint-disable-next-line camelcase, no-undef
__webpack_public_path__ = trackerConfig.webpackBuildUrl
